module.exports = new __parcel__URL__("step-permissions.1da1f2d5.svg").toString();